define(
	'Search/GlobalSearchBox',["jquery", "algoliasearch", "autocomplete", "Utility/ErrorHandler", "Track/GoalsManager"],
	function ($, algoliasearch, autocomplete, errorHandler, goalsManager) {
		"use strict";

		function GlobalSearchBox(searchResultsPageUrl, searchBoxId, algoliaApiKey, algoliaIndexName, algoliaApplicationId, contextLanguage, suggestionsLimit, noSuggestionsText) {

			var autoCompleteResultAttribute = 'default title';

			var typingTimer;
			var doneTypingInterval = 1500;

			$('.global-search-box').on('click', function (e) {
				cancelBubble(e);

				$(this).addClass("open");
				$('.global-search-wrapper').show();
				$('.global-search-input').focus();
			});

			$('.global-search-box').on('focusout', function (e) {
				cancelBubble(e);

				if (e.relatedTarget == null || ((e.relatedTarget.className.indexOf('global-search-button') <= 0) && (e.relatedTarget.className.indexOf('global-search-input') === -1))) {
					$(this).removeClass("open");
					$('.global-search-wrapper').hide();
				}
			});

			$('.global-search-button').on('click touchstart', function () {
				performSearch();
			});

			$('.global-search-input').keypress(function (e) {
				if (e.which === 13) {
					performSearch();
				}
			});

			function cancelBubble(e) {
				var evt = e ? e : window.event;
				if (evt.stopPropagation) evt.stopPropagation();
				if (evt.cancelBubble != null) evt.cancelBubble = true;
			};

			function performSearch() {
				var searchInput = $('.global-search-input').val();
				if (searchInput) {
					goalsManager.triggerSiteSearch(searchInput);
					var newUrl = searchResultsPageUrl + "?q=" + encodeURI(searchInput);
					$(window).attr('location', newUrl);
				}
			}

			autocomplete('#' + searchBoxId, { hint: false, debug: false }, [{
				source: function (query, callback) {
					var algoliaClient = algoliasearch(algoliaApplicationId, algoliaApiKey);
					var algoliaIndex = algoliaClient.initIndex(algoliaIndexName);
					algoliaIndex.search(query, { hitsPerPage: suggestionsLimit, facetFilters: '_language:' + contextLanguage }).then(function (answer) {
						//sitecore analytichs for search 
						clearTimeout(typingTimer);
						typingTimer = setTimeout(function () {
							console.log(query);
							goalsManager.triggerSiteSearch(query);
						}, doneTypingInterval);

						callback(answer.hits);
					}, function () {
						callback([]);
					});
				},
				displayKey: autoCompleteResultAttribute,
				templates: {
					suggestion: function (suggestion) {
						if (!suggestion._highlightResult.hasOwnProperty(autoCompleteResultAttribute)) {
							errorHandler.logError("Page " + suggestion._id + " is missing value for mandatory field " + autoCompleteResultAttribute);
						}

						return '<span class="global-search-autocomplete-highlight">' + suggestion._highlightResult[autoCompleteResultAttribute].value + '</span>';
					},
					empty: '<span class="global-search-highlight-no-results">' + noSuggestionsText + '</span>'
				}
			}]);

			$('#' + searchBoxId).on("autocomplete:selected", function () {
				sessionStorage.setItem("lnrs_session_autocomplete", "true");
			});
		}

		return function initGlobalSearchBox(args) {
			return args.IsExperienceEditorEditing ? null : new GlobalSearchBox(args.SearchResultsPageUrl,
				args.SearchBoxId, args.AlgoliaApiKey, args.AlgoliaIndexName, args.AlgoliaApplicationId,
				args.ContextLanguage, args.SuggestionsLimit, args.NoSuggestionsText);
		};
	});
